import React, { useEffect, useState } from "react";
import SitejabberLogo from "../../Assets/images/New/sitejabber.svg";

const SitejabberRatings = ({ rating }) => {

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const containerInStyles = {
        display: "flex",
        alignItems: "center",
        backgroundColor: "#e0e9f0",
        padding: "10px 20px",
        borderRadius: "8px",
        minWidth: isMobile ? "150px" : "150px",
        justifyContent: "center",
    };

    const ratingStyles = {
        fontSize: isMobile ? "20px" : "24px",
        fontWeight: "bold",
        color: "#333",
    };

    const logoImageStyles = {
        width: isMobile ? "180px" : "120px",
    };

    return (
        <div style={containerInStyles} className="mb-4">
            <span style={styles.logo}>
                <img src={SitejabberLogo} alt="Sitejabber Logo" style={logoImageStyles} />
            </span>
            <span style={ratingStyles}>{rating}</span>
        </div>
    );
};

const styles = {
    logo: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "8px",
    },
};

export default SitejabberRatings;
